module.exports = __webpack_public_path__ + "media/images/icon_yamori_default-eac7ebdda640b6dd3658aa2e96efa414.png";